import {Grid} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {Box, styled} from "@mui/system";
import Popover from "@mui/material/Popover";
import PopupState, {
  bindTrigger,
  bindPopover,
  bindToggle,
} from "material-ui-popup-state";

import img from "../../Assets/modal-link-img.svg";
import img2 from "../../Assets/info.svg";
import PageRoutes from "../../Config/PageRoutes";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";

const data = [
  {
    title: "",
    content: "",
    triggers: [],
    category: "",
    link: false,
  },
  {
    title: "EU multiannual control programme",
    content:
      "The EU MACP gathers data on the occurrence and possible MRL exceedances of pesticide residues in food placed on the European market that are statistically representative enough to estimate the exposure of EU consumers to these residues.",
    triggers: [
      "minimum number",
      "EU MACP",
      "EU Multi-Annual Control Programme (EU MACP)",
      "EU multiannual control programme (EU MACP)",
      "3-year cycle",
      "three-year cycle",
      "given number of samples by commodity",
    ],
    category: "Methodology",
    link: true,
  },
  {
    title: "MRL exceedance",
    content:
      "The pesticide residue concentration in mg/kg reported that is greater numerically than the maximum residue level.",
    triggers: [
      "MRL exceedances",
      "MRL exceedance",
      "exceeded numerically the MRL",
      "exceed the MRL",
      "exceeded the MRL",
      "exceedance of the MRL",
      "exceeding the MRL",
    ],
    category: "Terminology",
    link: true,
  },
  {
    title: "MRL exceedance rate",
    content:
      "Percentage given by dividing the number of samples with residues above the MRL by the total number of samples.",
    triggers: [
      "MRL exceedance rate",
      "MRL exceedances rate",
      "MRL exceedance rates",
    ],
    category: "Methodology",
    link: true,
  },
  {
    title: "The Maximum Residue Level",
    content:
      "Means the upper legal level of a concentration for a pesticide residue in or on food or feed set in accordance with Annex I of Regulation (EC) 396/2005, based on good agricultural practice and the lowest consumer exposure necessary to protect vulnerable consumers.",
    triggers: ["MRL", "MRLs"],
    category: "Terminology",
    link: true,
  },
  {
    title: "Quantifiable levels",
    content:
      "Results where the analyte is present in a concentration at or above the limit of quantification (LOQ), as reported by the Member States.",
    triggers: [
      "quantifiable levels",
      "quantifiable residues",
      "quantified",
      "quantified residues",
    ],
    category: "Methodology",
    link: true,
  },
  {
    title: "Quantification rate",
    content:
      "Percentage given by dividing the number of samples with residues quantified at a level above the LOQ by the total number of samples.",
    triggers: ["quantification rate", "quantification rates"],
    category: "Methodology",
    link: true,
  },
  {
    title: "Limit of Quantification",
    content:
      "The LOQ is the validated lowest residue concentration which can be quantified and reported by routine monitoring with validated control methods.",
    triggers: ["LOQ", "Limit of quantification"],
    category: "Methodology",
    link: true,
  },
  {
    title: "Non-compliant sample",
    content:
      "Sample with at least one quantified residue that after considering the measurement uncertainty, both tails of the dispersion is above the maximum residue level.",
    triggers: [
      "non-compliant",
      "non-compliance",
      "non-compliant samples",
      "not compliant",
    ],
    category: "Terminology",
    link: true,
  },
  {
    title: "Non-compliance rate",
    content:
      "Percentage given by dividing the number of samples non-compliant by the total number of samples.",
    triggers: [
      "non-compliant rate",
      "non-compliance rate",
      "non-compliance rates",
    ],
    category: "Methodology",
    link: true,
  },
  {
    title:
      "Samples with quantified residues within the legal limits (below or at the MRL)",
    content:
      "These samples contained quantified residues (above the LOQ) of one or several pesticides and in concentrations below or at the MRL.",
    triggers: [
      "quantified at or above the limit of quantification",
      "above the LOQ but below the MRL",
      "above the LOQ but below or at the MRL",
      "above the LOQ but below or at the Maximum residue level, or MRL",
      "residues at or above the LOQ but below or equal to the MRL",
      "below the MRL",
      "at or above the LOQ but below or equal to the MRL",
      "below the LOQ",
    ],
    category: "Methodology",
    link: true,
  },
  {
    title: "Pesticide residues",
    content:
      "A 'pesticide residue' refers to measurable amount of an active substance and/or related metabolites and/or degradation products of active substances that can be found on harvested crops or in foods of animal origin, currently or formerly used in plant protection products.",
    triggers: ["pesticide residues", "Pesticide residues"],
    category: "Terminology",
    link: true,
  },
  {
    title: "Samples with multiple residues",
    content:
      "The presence of multiple pesticide residues in the sampe sample does not constitute non-compliance with MRL legislation as long as the MRL is not exceeded individually by residue. However, products with multiple residues should be assessed carefully by the national authorities (for example, to consider whether combinations of pesticides are being used deliberately to circumvent MRL limits on single substances).",
    triggers: [
      "samples with multiple residues",
      "Multiple residues",
      "multiple residues",
    ],
    category: "Terminology",
    link: true,
  },
  {
    title: "Samples with multiple residues",
    content:
      "The presence of multiple pesticide residues in the sampe sample does not constitute non-compliance with MRL legislation as long as the MRL is not exceeded individually by residue. However, products with multiple residues should be assessed carefully by the national authorities (for example, to consider whether combinations of pesticides are being used deliberately to circumvent MRL limits on single substances).",
    triggers: [
      "percentage of multiple residues",
      "percentages of multiple residues",
      "Multiple residues",
      "multiple residues",
    ],
    category: "Terminology",
    link: true,
  },
  {
    title: "Third countries",
    content:
      "From the EU perspective, a third country is all the countries world-wide, except those EFTA countries considered second countries and those in the EU that are considered first countries. In other words, is the different commercial relations among the EU and the rest of countries (as an example: USA is a third country as it is India).",
    triggers: ["third countries", "third country"],
    category: "Terminology",
    link: true,
  },
  {
    title: "Persistent organic pollutants",
    content:
      "Non-approved pesticides present in the food chain due to their persistence. These are gather under the Stockholm Convention on Persistent Organic Pollutants.",
    triggers: ["POP", "persistent organic pollutants"],
    category: "Terminology",
    link: true,
  },
  {
    title: "Domestic samples",
    content:
      "Domestic samples are samples grown in the country that reports the results of its analysis.",
    triggers: ["domestic samples", "domestic"],
    category: "Terminology",
    link: true,
  },
  {
    title: "Reporting countries",
    content:
      "The 27 EU Member States, the United Kingdom in respect of Northern Ireland, Norway and Iceland.",
    triggers: [
      "reporting countries",
      "Reporting countries",
      "reporting country",
    ],
    category: "Terminology",
    link: true,
  },
  {
    title: "MANCP",
    content:
      "The MANCP are sampling programmes that complement the EU MACP. They focus on products likely to contain pesticide residues or for which MRLs were exceeded in previous monitoring programmes.",
    triggers: [
      "context of the MANCP",
      "context of the MANCPs",
      "context of the Multiannual National Control Programme (MANCP)",
    ],
    category: "Terminology",
    link: true,
  },
  {
    title: "Residue definition (RD)",
    content:
      "The residue definition of a pesticide includes other active substances, metabolites and/or breakdown or reaction products, and Member States shall report their analysis results in accordance with the full wording of the RD. Additionally, the results of all analytes that are part of it must be submitted separately if they are measured individually. RDs in the context of this visualisation refer to the residue definition for enforcement, which may be the same as or differ from the residue definitions derived for risk assessments.",
    triggers: ["Residue definition", "metabolites", "(RD)"],
    category: "Terminology",
    link: true,
  },
  {
    title: "MANCP",
    content:
      "The MANCP are mainly risk-based sampling programmes that are complementary to the EU MACP. They focus on products likely to contain pesticide residues or for which MRL infringements have been identified in previous monitoring programmes.",
    triggers: ["National programme"],
    category: "Terminology",
    link: true,
  },
  {
    title: "Processing factor",
    content:
      "The processing factor (PF) reflects the transfer of a pesticide residue from the raw agricultural commodities (RAC) to the processed product. The residue concentration in food as consumed strongly depends on the processing procedures applied prior to consumption. The PF is a pesticide-specific parameter. To check for MRL compliance, it is necessary to convert the MRL based on the RAC to that of the processed commodity using a PF, and then to check against the analytical result determined on the processed commodity.",
    triggers: ["Processed food", "processing factor"],
    category: "Methodology",
    link: true,
  },
  {
    title: "Windsor Framework",
    content:
      "In accordance with the Agreement on the withdrawal of the United Kingdom of Great Britain and Northern Ireland from the European Union and the European Atomic Energy Community, and in particular Article 5(4) of the Windsor Framework (see Joint Declaration No 1/2023 of the Union and the United Kingdom in the Joint Committee established by the Agreement on the withdrawal of the United Kingdom of Great Britain and Northern Ireland from the European Union and the European Atomic Energy Community of 24 March 2023, OJ L 102, 17.4.2023, p.87) in conjunction with section 24 of Annex 2 to that Framework, for the purposes of this Regulation, references to Member States include the United Kingdom in respect of Northern Ireland. ",
    triggers: ["the United Kingdom (Northern Ireland)", "EU Member States"],
    category: "Methodology",
    link: false,
  },
  {
    title: "Windsor Framework",
    content:
      "In accordance with the Agreement on the withdrawal of the United Kingdom of Great Britain and Northern Ireland from the European Union and the European Atomic Energy Community, and in particular Article 5(4) of the Windsor Framework (see Joint Declaration No 1/2023 of the Union and the United Kingdom in the Joint Committee established by the Agreement on the withdrawal of the United Kingdom of Great Britain and Northern Ireland from the European Union and the European Atomic Energy Community of 24 March 2023, OJ L 102, 17.4.2023, p.87) in conjunction with section 24 of Annex 2 to that Framework, for the purposes of this Regulation, references to Member States include the United Kingdom in respect of Northern Ireland.",
    triggers: [""],
    category: "Methodology",
    link: false,
  },
  {
    title: "Windsor Framework Test",
    content: "In accordance with the Agreement on the withdrawal of the United Kingdom of Great Britain and Northern Ireland from the European Union and the European Atomic Energy Community, and in particular Article 5(4) of the Windsor Framework (see Joint Declaration No 1/2023 of the Union and the United Kingdom in the Joint Committee established by the Agreement on the withdrawal of the United Kingdom of Great Britain and Northern Ireland from the European Union and the European Atomic Energy Community of 24 March 2023, OJ L 102, 17.4.2023, p.87) in conjunction with section 24 of Annex 2 to that Framework, for the purposes of this Regulation, references to Member States include the United Kingdom in respect of Northern Ireland.",
    triggers: ["Kosovo Disclaimer"],
    category: "Methodology",
    paragraphs: [
      {title: "Kosovo", content: "This designation is without prejudice to positions on status, and is in line with UNSCR 1244/1999 and the ICJ Opinion on the Kosovo declaration of independence."},
      {title: "Palestine", content: "This designation shall not be construed as recognition of a State of Palestine and is without prejudice to the individual positions of the Member States on this issue."},
    ],
    link: false,
  },
  {
    title: "Composite food products",
    content:
      "Food made of more than one products, either plant base raw agricultural commodities or/and animal commodities. The applicable MRL needs to be recalculated depending on the ingredients and proportion of these.",
    triggers: ["composite food products", "composite food products and feed"],
    category: "Terminology",
    link: false,
  },
  {
    title: "RASFF:Rapid Alert System for Food and Feed (RASFF)",
    content:
      "The RASFF enables competent authorities to rapidly exchange information on serious direct or indirect risks to human health in relation to food or feed, or serious risks to human or animal health or to the environment in relation to feed.",
    triggers: ["RASFF"],
    category: "Terminology",
    link: false,
  },
];

const ModalTrigger = (props) => {
  const navigate = useNavigate();

  const navigateToImportantConcepts = () => {
    navigate(
      "../" + PageRoutes.IMPORTANT_CONCEPTS
      // , { replace: true }
    );
  };

  const found = data.find((d) => d.triggers.indexOf(props.text) > -1) || {triggers: []};

  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      { (popupState) => (
        <>
          <i { ...bindTrigger(popupState) } style={ props.style }>
            {/* Only show the icon if triggers[0] is "" or "Kosovo Disclaimer" */ }
            { (found.triggers[0] === "" || found.triggers[0] === "Kosovo Disclaimer") ? (
              <img
                alt="more information"
                { ...bindTrigger(popupState) }
                src={ img2 }
                style={ {
                  cursor: "pointer",
                  paddingLeft: "2px",
                  paddingRight: "2px",
                } }
              />
            ) : (
              // Show props.text only if condition is NOT met
              props.text
            ) }
          </i>
          <Popover
            sx={ {zIndex: "20000"} }
            { ...bindPopover(popupState) }
            anchorOrigin={ {
              vertical: "center",
              horizontal: "center",
            } }
            transformOrigin={ {
              vertical: "center",
              horizontal: "center",
            } }
          >
            <Box
              className="popoverModal"
              borderRadius="5px"
              border="#22294D 1px solid"
            >
              <Grid container flexDirection="column" p="10px">
                <Box
                  display="flex"
                  sx={ {
                    fontSize: "9px",
                    color: "#22294D",
                  } }
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box>
                    <span style={ {textTransform: "uppercase"} }>
                      { found.category }
                    </span>
                  </Box>

                  <CancelOutlinedIcon
                    cursor="pointer"
                    { ...bindToggle(popupState) }
                  />
                </Box>

                <Grid item>
                  <Box sx={ {maxWidth: "360px"} }>
                    <h1 className="title">{ found.title }</h1>
                    <p>{ found.content }</p>
                    { found.paragraphs && found.paragraphs.map((p) => {
                      return (
                        <>
                          <h2 className="title">{ p.title }</h2>
                          <p>{ p.content }</p>
                        </>
                      );
                    }) }
                  </Box>
                </Grid>
                { found.link && (
                  <Grid item>
                    <Box display="flex" alignContent="center">
                      <p
                        style={ {
                          marginTop: "0px",
                          marginBottom: "0px",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                        } }
                      >
                        <b>More important concepts</b>
                      </p>

                      <Box
                        display="flex"
                        alignItems="center"
                        sx={ {paddingLeft: "3px"} }
                      >
                        <ArrowCircleRightOutlinedIcon
                          cursor="pointer"
                          onClick={ navigateToImportantConcepts }
                        />
                      </Box>
                    </Box>
                  </Grid>
                ) }
              </Grid>
            </Box>
          </Popover>
        </>
      ) }
    </PopupState>
  );
};

export default ModalTrigger;
